import { useRoutes } from 'react-router-dom';

// routes
import GuestRoutes from './GuestRoutes';
import UserRoutes from './UserRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([GuestRoutes, LoginRoutes, UserRoutes]);
}
